<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <Loading v-if="loading"/>
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="col-auto">
                <card shadow class="card-profile mt--400" no-body>
                   <div class="card-header text-center">
                    <div class="row">
                      <h3 class="col-10">
                          Staff List
                      </h3>
                     <!-- <a class="btn btn-warning col-2 float-right" href="/#/absent"><i class="ni ni-circle-08 nix3"></i> Absent Staff</a> -->
                    </div>

                   </div>
                  
                    <div class="p-4">
                        <div class="text-center">
                            <div class="row justify-content-center mt-2">
                                 <div class="col-lg-12">
                                    <table class="table table-striped table-responsive" id="myTable">
                                    <thead>
                                        <tr>                                
                                            <th scope="col">Name</th>
                                            <th scope="col">Email</th>
                                            <th scope="col">Phone</th>
                                            <th scope="col">Branch</th>
                                            <th scope="col">Department</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Date Added</th>
                                            <th scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(staff,index) in staffList" :key="index" >
                                          <td>{{ staff["OfficialName"] }}</td>
                                          <td>{{ staff["CompanyEmail"] }}</td>
                                          <td>{{ staff["MobileNumber"] }}</td>
                                          <td>{{ staff["Branch.Name"] }}</td>
                                          <td>{{ staff["Department.Name"] }}</td>
                                          <td v-if = "staff['Suspended']">
                                            <span class="badge badge-danger">Suspended/Terminated</span>
                                          </td>
                                          <td v-else>
                                             <span class="badge badge-success">Active</span>
                                          </td>
                                          <td>
                                             {{ moment(staff["CreatedOn"]).format("MMM Do YY HH:mm") }}
                                          </td>
                                          <td>
                                            <router-link to="/attendance-track" tag="button"  class="btn btn-secondary btn-sm mb-2"><i class="fa fa-calendar"></i> View Calendar</router-link>
                                            <router-link to="/attendance-track" tag="button" class="btn btn-primary btn-sm"><i class="fa fa-bar-chart"></i> View Attendance</router-link>
                                          </td>
                                        </tr>
                                    </tbody>
                                  </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
import $ from 'jquery'
import 'datatables.net-dt'

import '../../node_modules/datatables.net-buttons/js/jquery.dataTables.min.js'
import '../../node_modules/datatables.net-buttons/js/dataTables.buttons.js'
import '../../node_modules/datatables.net-buttons/js/jszip.min.js'
import '../../node_modules/datatables.net-buttons/js/pdfmake.min.js'
import '../../node_modules/datatables.net-buttons/js/vfs_fonts.js'
import '../../node_modules/datatables.net-buttons/js/buttons.html5.min.js'
import '../../node_modules/datatables.net-bs4/js/dataTables.bootstrap4.js'

import Loading from './DataLoading'
import moment from "moment"

export default {
    components: { 
       Loading
    },
    data(){
        return{
            staffList: this.$store.state.staff,
            loading:false,   
        }
    },
    mounted(){
      this.getStaff()
        
    },
    computed:{
              moment()  {
                return moment
                 },
    },
    methods:{
        getStaff(){
            this.loading = true                
    
            this.$store.dispatch("getStaff")
            .then(()=>{
                this.staffList =this.$store.state.staff;
                // console.log();

                $('#myTable').DataTable().destroy();
                this.$nextTick().then(()=>$('#myTable').DataTable({
                        dom: 'Bfrtip',
                        buttons: [
                            'copyHtml5',
                            'excelHtml5',
                            'csvHtml5',
                            'pdfHtml5'
                        ]
                    }))
                                  
                 this.loading = false
                
                
            })
        }
     
        
    }
};
</script>

<style>

</style>
